import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ApiService } from '@services';

/**
 * tenants service.
 *
 * @author Ruslan Kolesov
 * @class TenantsServiceClass
 * @category Services
 */
var TenantsServiceClass = /*#__PURE__*/function () {
  function TenantsServiceClass() {
    _classCallCheck(this, TenantsServiceClass);
  }

  _createClass(TenantsServiceClass, [{
    key: "apiTenantsGet",
    value:
    /**
     * Tenants get api function.
     *
     * @author Ruslan Kolesov
     * @return {Promise<ApiError | AxiosResponse<OrganizationsResponseType>>} admin console users.
     */
    function () {
      var _apiTenantsGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", ApiService.apiGet('/tenants', _objectSpread({}, params)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function apiTenantsGet(_x) {
        return _apiTenantsGet.apply(this, arguments);
      }

      return apiTenantsGet;
    }()
    /**
     * Tenants name get api function.
     *
     * @author Ruslan Kolesov
     * @return {Promise<ApiError | AxiosResponse<OrganizationsNamesResponseType>>} admin console tenants names.
     */

  }, {
    key: "apiTenantsNamesGet",
    value: function () {
      var _apiTenantsNamesGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", ApiService.apiGet('/tenants/names', _objectSpread({}, params)));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function apiTenantsNamesGet(_x2) {
        return _apiTenantsNamesGet.apply(this, arguments);
      }

      return apiTenantsNamesGet;
    }()
    /**
     * Change tenant status put api function.
     *
     * @author Ruslan Kolesov
     * @return {Promise<ApiError | AxiosResponse<string>>} string.
     */

  }, {
    key: "apiChangeTenantStatusPut",
    value: function () {
      var _apiChangeTenantStatusPut = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(id, params) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", ApiService.apiPut("/tenants/change-status/".concat(id), params === null || params === void 0 ? void 0 : params.body, _objectSpread({}, params)));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function apiChangeTenantStatusPut(_x3, _x4) {
        return _apiChangeTenantStatusPut.apply(this, arguments);
      }

      return apiChangeTenantStatusPut;
    }()
    /**
     * Edit tenant put api function.
     *
     * @author Ruslan Kolesov
     * @return {Promise<ApiError | AxiosResponse<string>>} string.
     */

  }, {
    key: "apiEditTenantPut",
    value: function () {
      var _apiEditTenantPut = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(id, params) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", ApiService.apiPut("/tenants/".concat(id || ''), params === null || params === void 0 ? void 0 : params.body, _objectSpread({}, params)));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function apiEditTenantPut(_x5, _x6) {
        return _apiEditTenantPut.apply(this, arguments);
      }

      return apiEditTenantPut;
    }()
    /**
     * Creating tenant post api function.
     *
     * @author Ruslan Kolesov
     * @return {Promise<ApiError | AxiosResponse<string>>} string.
     */

  }, {
    key: "apiCreateTenantPost",
    value: function () {
      var _apiCreateTenantPost = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(id, params) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", ApiService.apiPost("/tenants/".concat(id), _objectSpread({}, params === null || params === void 0 ? void 0 : params.body), _objectSpread({}, params)));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function apiCreateTenantPost(_x7, _x8) {
        return _apiCreateTenantPost.apply(this, arguments);
      }

      return apiCreateTenantPost;
    }()
    /**
     * Delete tenant put api function.
     *
     * @author Ruslan Kolesov
     * @return {Promise<ApiError | AxiosResponse<string>>} string.
     */

  }, {
    key: "apiDeleteTenantPost",
    value: function () {
      var _apiDeleteTenantPost = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(id, params) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", ApiService.apiPost("/tenants/delete/".concat(id || ''), params === null || params === void 0 ? void 0 : params.body, _objectSpread({}, params)));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function apiDeleteTenantPost(_x9, _x10) {
        return _apiDeleteTenantPost.apply(this, arguments);
      }

      return apiDeleteTenantPost;
    }()
    /**
     * Search tenants post api function.
     *
     * @author Ruslan Kolesov
     * @return {Promise<ApiError | AxiosResponse<OrganizationsResponseType>>} search tenants list promise.
     */

  }, {
    key: "apiSearchTenantsPost",
    value: function () {
      var _apiSearchTenantsPost = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(params) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", ApiService.apiPost('/search', _objectSpread({}, params === null || params === void 0 ? void 0 : params.body), _objectSpread({
                  prefixURL: '/tenants'
                }, params)));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function apiSearchTenantsPost(_x11) {
        return _apiSearchTenantsPost.apply(this, arguments);
      }

      return apiSearchTenantsPost;
    }()
  }]);

  return TenantsServiceClass;
}();

var TenantsService = new TenantsServiceClass();
export { TenantsService };